<template>
    <div class="contents">
        <div class="container-fluid">
            <BirthdayNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Edit Template Ucapan
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/birthday/template" style="display: inline-flex; margin: 5px">
                                <button class="btn px-15 btn-secondary text-white">
                                    <i class="fas fa-arrow-left fs-16"></i>
                                    Kembali
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div v-if="isLoading" class="text-center p-5">
                        <i class="fas fa-spinner fa-spin fa-2x"></i>
                        <p>Memuat data...</p>
                    </div>
                    <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form @submit.prevent="updateTemplate">
                            <div class="form-group">
                                <label>Judul Template <span class="text-danger">*</span></label>
                                <input 
                                    type="text" 
                                    v-model="form.title" 
                                    class="form-control" 
                                    placeholder="Contoh: Ucapan Ulang Tahun Standar"
                                    required
                                />
                            </div>

                            <div class="form-group">
                                <label>Isi Pesan <span class="text-danger">*</span></label>
                                <CustomTextarea v-model="form.message" />
                                <small class="form-text text-muted">
                                    <i class="fas fa-info-circle"></i> 
                                    Variable yang tersedia: <code>{nama}</code>, <code>{tanggal}</code>, <code>{umur}</code>
                                </small>
                            </div>

                            <div class="form-group">
                                <label>Upload Media (Opsional)</label>
                                <input 
                                    ref="file" 
                                    type="file" 
                                    @change="onFileChange" 
                                    class="form-control"
                                    accept=".jpg,.jpeg,.png,.mp4,.mov"
                                />
                                <small class="form-text text-muted">
                                    Format yang didukung: JPG, PNG, MP4, MOV
                                </small>
                                <div v-if="form.media_url" class="mt-2">
                                    <img 
                                        v-if="isImage(form.media_url)"
                                        :src="form.media_url" 
                                        alt="Preview" 
                                        style="max-width: 200px; max-height: 200px; border-radius: 8px;"
                                        onerror="this.style.display='none'"
                                    />
                                    <div v-else class="p-2 bg-light rounded">
                                        <i class="fas fa-file-video"></i> Media terpilih
                                    </div>
                                    <button 
                                        type="button" 
                                        @click="removeMedia" 
                                        class="btn btn-sm btn-danger mt-2"
                                    >
                                        <i class="fas fa-times"></i> Hapus Media
                                    </button>
                                </div>
                                <div v-else-if="file" class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-file"></i> File terpilih: {{ file.name }}
                                    </small>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="form-check">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        v-model="form.is_default" 
                                        :value="1" 
                                        :unchecked-value="0"
                                        id="check-default"
                                    />
                                    <label class="form-check-label" for="check-default">
                                        Tandai sebagai Template Default
                                    </label>
                                </div>
                                <small class="form-text text-muted">
                                    Template default akan digunakan jika tidak ada template yang dipilih secara manual
                                </small>
                            </div>

                            <div class="form-group">
                                <div class="form-check">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        v-model="form.random_enabled" 
                                        :value="1" 
                                        :unchecked-value="0"
                                        id="check-random"
                                    />
                                    <label class="form-check-label" for="check-random">
                                        Aktifkan Random Template
                                    </label>
                                </div>
                                <small class="form-text text-muted">
                                    Template ini akan ikut dalam randomisasi jika fitur random template diaktifkan
                                </small>
                            </div>

                            <div class="form-group" v-if="form.message">
                                <label>Preview Pesan dengan Data Kontak</label>
                                <div class="mb-3">
                                    <label class="form-label small">Pilih Kontak untuk Preview:</label>
                                    <select 
                                        v-model="selectedContactId" 
                                        class="form-control form-control-sm"
                                        @change="updatePreview"
                                        :disabled="isLoadingContacts"
                                    >
                                        <option value="">-- Pilih Kontak (Data Sample) --</option>
                                        <option 
                                            v-for="contact in birthdayContacts" 
                                            :key="contact.id" 
                                            :value="contact.id"
                                        >
                                            {{ contact.name }} - {{ formatBirthDate(contact.birth_date) }}
                                        </option>
                                    </select>
                                    <small class="form-text text-muted" v-if="!isLoadingContacts">
                                        <i class="fas fa-info-circle"></i> 
                                        Pilih kontak untuk melihat preview pesan dengan data real ({{ birthdayContacts.length }} kontak tersedia)
                                    </small>
                                    <small class="form-text text-muted" v-else>
                                        <i class="fas fa-spinner fa-spin"></i> Memuat kontak...
                                    </small>
                                </div>
                                <div class="card bg-light p-3">
                                    <div v-if="form.media_url && isImage(form.media_url)" class="mb-2">
                                        <img 
                                            :src="form.media_url" 
                                            alt="Preview" 
                                            style="max-width: 200px; max-height: 200px; border-radius: 8px;"
                                            onerror="this.style.display='none'"
                                        />
                                    </div>
                                    <div v-else-if="form.media_url && !isImage(form.media_url)" class="mb-2">
                                        <div class="p-2 bg-light rounded">
                                            <i class="fas fa-file-video"></i> Video/Media
                                        </div>
                                    </div>
                                    <div v-html="previewMessage"></div>
                                    <div v-if="selectedContact && selectedContact.birth_date" class="mt-3 pt-3 border-top">
                                        <small class="text-muted">
                                            <strong>Data Kontak:</strong><br>
                                            Nama: {{ selectedContact.name }}<br>
                                            Tanggal Lahir: {{ formatBirthDate(selectedContact.birth_date) }}<br>
                                            Umur: {{ calculateAge(selectedContact.birth_date) }} tahun
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="button-group d-flex pt-25">
                                <button 
                                    type="submit" 
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block"
                                    :disabled="isSaving || isUploading"
                                >
                                    <i class="fas fa-save"></i> 
                                    {{ isUploading ? 'Mengupload media...' : (isSaving ? 'Menyimpan...' : 'Update Template') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTextarea from "@/components/module/CustomTextarea.vue";
import BirthdayNavigation from "@/components/birthday/Navigation.vue";

export default {
    components: {
        CustomTextarea,
        BirthdayNavigation
    },
    data() {
        return {
            form: {
                id: null,
                title: "",
                message: "",
                media_url: "",
                is_default: 0,
                random_enabled: 0
            },
            file: null,
            isSaving: false,
            isLoading: true,
            isUploading: false,
            birthdayContacts: [],
            selectedContactId: "",
            selectedContact: null,
            isLoadingContacts: false
        };
    },
    computed: {
        previewMessage() {
            if (!this.form.message) return "";
            let message = this.form.message;
            
            // Use real contact data if selected, otherwise use sample data
            if (this.selectedContact && this.selectedContact.birth_date) {
                const contactName = this.selectedContact.name || "Nama Kontak";
                const birthDate = this.formatBirthDate(this.selectedContact.birth_date);
                const age = this.calculateAge(this.selectedContact.birth_date);
                
                message = message.replace(/\{nama\}/g, `<strong>${contactName}</strong>`);
                message = message.replace(/\{tanggal\}/g, `<strong>${birthDate}</strong>`);
                message = message.replace(/\{umur\}/g, `<strong>${age}</strong>`);
            } else {
                // Use sample data
                message = message.replace(/\{nama\}/g, "<strong>John Doe</strong>");
                message = message.replace(/\{tanggal\}/g, "<strong>25 Desember 2024</strong>");
                message = message.replace(/\{umur\}/g, "<strong>30</strong>");
            }
            
            // Convert newlines to <br>
            message = message.replace(/\n/g, "<br>");
            return message;
        }
    },
    mounted() {
        this.loadTemplate();
        this.loadBirthdayContacts();
    },
    methods: {
        isImage(url) {
            if (!url) return false;
            return /\.(jpg|jpeg|png|gif)$/i.test(url);
        },
        onFileChange(e) {
            const selectedFile = e.target.files[0];
            if (selectedFile) {
                this.file = selectedFile;
            }
        },
        removeMedia() {
            this.file = null;
            this.form.media_url = "";
            if (this.$refs.file) {
                this.$refs.file.value = "";
            }
        },
        async loadTemplate() {
            const id = this.$route.query.id;
            if (!id) {
                this.$toast.error("ID template tidak ditemukan");
                this.$router.push("/birthday/template");
                return;
            }

            this.isLoading = true;
            try {
                const response = await this.$store.dispatch("birthday/birthday_template_one", id);
                const template = response.data.data.template;
                this.form = {
                    id: template.id,
                    title: template.title,
                    message: template.message || "",
                    media_url: template.media_url || "",
                    is_default: template.is_default || 0,
                    random_enabled: template.random_enabled === true || template.random_enabled === 1 ? 1 : 0
                };
            } catch (err) {
                this.$toast.error("Gagal memuat template");
                this.$router.push("/birthday/template");
            } finally {
                this.isLoading = false;
            }
        },
        async loadBirthdayContacts() {
            this.isLoadingContacts = true;
            try {
                // Load contacts with birthdays (use "month" filter to get more contacts)
                const response = await this.$store.dispatch("birthday/birthday_list", { filter: "month" });
                this.birthdayContacts = response.data.data.birthdays || [];
                
                // If no contacts found, try with "all" or empty filter
                if (this.birthdayContacts.length === 0) {
                    const responseAll = await this.$store.dispatch("birthday/birthday_list", { filter: "" });
                    this.birthdayContacts = responseAll.data.data.birthdays || [];
                }
            } catch (err) {
                console.error("Failed to load birthday contacts:", err);
                this.birthdayContacts = [];
            } finally {
                this.isLoadingContacts = false;
            }
        },
        updatePreview() {
            if (this.selectedContactId) {
                this.selectedContact = this.birthdayContacts.find(c => c.id == this.selectedContactId) || null;
            } else {
                this.selectedContact = null;
            }
        },
        formatBirthDate(birthDate) {
            if (!birthDate) return "";
            
            // Parse date from YYYY-MM-DD format
            const date = new Date(birthDate);
            if (isNaN(date.getTime())) return birthDate;
            
            // Format to "01 Januari 2003" (Indonesian format with leading zero)
            const months = [
                "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                "Juli", "Agustus", "September", "Oktober", "November", "Desember"
            ];
            
            const day = String(date.getDate()).padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            
            return `${day} ${month} ${year}`;
        },
        calculateAge(birthDate) {
            if (!birthDate) return 0;
            
            const birth = new Date(birthDate);
            if (isNaN(birth.getTime())) return 0;
            
            const today = new Date();
            let age = today.getFullYear() - birth.getFullYear();
            const monthDiff = today.getMonth() - birth.getMonth();
            
            // Adjust age if birthday hasn't occurred this year
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
                age--;
            }
            
            return age;
        },
        async updateTemplate() {
            if (!this.form.title || !this.form.message) {
                this.$toast.error("Judul dan isi pesan wajib diisi");
                return;
            }

            this.isSaving = true;
            this.isUploading = false;

            try {
                // Upload file to CDN if new file is selected
                if (this.file) {
                    this.isUploading = true;
                    const formData = new FormData();
                    formData.append('file', this.file);
                    const response = await this.$store.dispatch('cdn_upload', formData);
                    if (response && response.data && response.data.data && response.data.data.url) {
                        this.form.media_url = response.data.data.url;
                    }
                    this.isUploading = false;
                }

                this.form.random_enabled = this.form.random_enabled == true || this.form.random_enabled == 1 ? 1 : 0;
                this.form.is_default = this.form.is_default == true || this.form.is_default == 1 ? 1 : 0;
                await this.$store.dispatch("birthday/birthday_template_update", this.form);
                this.$toast.success("Template berhasil diupdate");
                this.$router.push("/birthday/template");
            } catch (err) {
                this.$toast.error(err.response?.data?.message || "Gagal mengupdate template");
            } finally {
                this.isSaving = false;
                this.isUploading = false;
            }
        }
    }
};
</script>

<style scoped>
.form-group {
    margin-bottom: 20px;
}

.form-check {
    margin-top: 10px;
}

code {
    background: #f4f4f4;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    color: #d63384;
}

.card.bg-light {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6;
}
</style>

